/* Frontier Organics — theme behaviour. No frameworks, no dependencies. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- header height var + scrolled state ---- */
  var header = document.querySelector('[data-header]');
  function measure() {
    if (!header) return;
    document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  }
  measure();
  window.addEventListener('resize', measure, { passive: true });

  if (header) {
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if ((y > 12) !== (lastY > 12)) header.classList.toggle('header--scrolled', y > 12);
      lastY = y;
    }, { passive: true });
  }

  /* ---- mobile drawer ---- */
  var burger = document.querySelector('[data-burger]');
  var drawer = document.querySelector('[data-drawer]');
  function setDrawer(open) {
    if (!drawer || !burger) return;
    drawer.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    } else {
      burger.focus();
    }
  }
  if (burger) burger.addEventListener('click', function () {
    setDrawer(burger.getAttribute('aria-expanded') !== 'true');
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function () { setDrawer(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      setDrawer(false);
      document.querySelectorAll('.mega.is-open').forEach(function (m) { closeMega(m); });
    }
    /* Keep Tab inside the drawer while it's open. */
    if (e.key === 'Tab' && drawer && drawer.classList.contains('is-open')) {
      var items = drawer.querySelectorAll('a[href], button:not([disabled])');
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---- mega menu ---- */
  function closeMega(mega) {
    mega.classList.remove('is-open');
    var t = document.querySelector('[aria-controls="' + mega.id + '"]');
    if (t) { t.setAttribute('aria-expanded', 'false'); t.classList.remove('is-open'); }
  }
  document.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
    var mega = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!mega) return;
    var wrapper = trigger.closest('[data-mega-wrap]') || trigger.parentElement;
    var timer;
    function open() {
      clearTimeout(timer);
      document.querySelectorAll('.mega.is-open').forEach(function (m) { if (m !== mega) closeMega(m); });
      mega.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      trigger.classList.add('is-open');
    }
    function scheduleClose() { timer = setTimeout(function () { closeMega(mega); }, 180); }
    wrapper.addEventListener('mouseenter', open);
    wrapper.addEventListener('mouseleave', scheduleClose);
    mega.addEventListener('mouseenter', function () { clearTimeout(timer); });
    mega.addEventListener('mouseleave', scheduleClose);
    trigger.addEventListener('focus', open);
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      mega.classList.contains('is-open') ? closeMega(mega) : open();
    });
    mega.addEventListener('focusout', function (e) {
      if (!mega.contains(e.relatedTarget) && e.relatedTarget !== trigger) closeMega(mega);
    });
  });

  /* ---- scroll reveal --------------------------------------------------
     Used for the Creed only. Everything else on the site renders immediately.
     Some embedded viewers and in-app browsers don't run IntersectionObserver
     against the real scroll container, which leaves content invisible while
     it still occupies full height — a far worse outcome than no animation.
     So: arm the hidden state only from JS, and carry four failsafes.
  --------------------------------------------------------------------- */
  var revealables = document.querySelectorAll('.creed__line');

  function revealAll() {
    revealables.forEach(function (el) { el.classList.add('is-in'); });
  }

  if (!revealables.length) {
    // nothing to do
  } else if (reduce || !('IntersectionObserver' in window)) {
    revealAll();
  } else {
    document.documentElement.classList.add('reveal-armed');

    // Creed lines cascade in sequence rather than all at once.
    document.querySelectorAll('[data-creed]').forEach(function (creed) {
      creed.querySelectorAll('.creed__line').forEach(function (line, i) {
        line.style.transitionDelay = (i * 80) + 'ms';
      });
    });

    var fired = false, io;
    try {
      io = new IntersectionObserver(function (entries) {
        fired = true;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
      revealables.forEach(function (el) { io.observe(el); });
    } catch (err) {
      revealAll();
      return;
    }

    // Failsafe 1 — anything already within the viewport on load shows now.
    requestAnimationFrame(function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      revealables.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 1.1 && r.bottom > 0) el.classList.add('is-in');
      });
    });

    // Failsafe 2 — observer never reported? Then it isn't going to. Show all.
    setTimeout(function () {
      if (!fired) { io.disconnect(); revealAll(); }
    }, 1500);

    // Failsafe 3 — hard backstop regardless of cause.
    setTimeout(revealAll, 2500);
  }

  /* ---- quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.min || '1', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- variant selection ---- */
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var form = root.closest('form');
    var data;
    try { data = JSON.parse(root.getAttribute('data-variants')); } catch (err) { return; }
    var idField = form && form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price-target]');
    var addBtn = form && form.querySelector('[data-add]');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('input:checked'), function (i) { return i.value; });
    }
    function sync() {
      var picked = selected();
      var match = data.find(function (v) {
        return v.options.every(function (o, i) { return o === picked[i]; });
      });
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available
          ? (addBtn.getAttribute('data-label-add') || 'Add to cart')
          : (addBtn.getAttribute('data-label-out') || 'Sold out');
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      }
    }
    root.addEventListener('change', sync);
    sync();
  });

  /* ---- newsletter (Shopify customer form enhancement) ---- */
  document.querySelectorAll('[data-signup]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    });
  });

  /* ---- marquee: duplicate the group so the loop is seamless ---- */
  document.querySelectorAll('[data-marquee]').forEach(function (track) {
    var group = track.firstElementChild;
    if (group && track.children.length === 1) track.appendChild(group.cloneNode(true));
  });

})();
